/**
 * Convert UTC timestamp to custom timezone and add client local timezone offset
 * Used for `new Date()` object or `date-fns/format`
 */
const convertUTCToTimezone = (timestamp: number, gmtTimezone: number): number => {
    const timezoneOffset = gmtTimezone * 60 * 60 * 1000;
    const clientOffset = new Date(timestamp).getTimezoneOffset() * 60 * 1000;

    return timestamp + timezoneOffset + clientOffset;
};

export default convertUTCToTimezone;
